import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToastrService } from 'ngx-toastr';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Table } from '../shared/table/table';
import { AppIcons } from '../../core/icons/fa-icons';
import { Popup } from '../../core/shared/components/popup/popup';
import { DynamicFieldConfig } from '../../core/shared/dynamic-form/form-config.model';
import { Setup } from '../setup/shared/service/setup';
import { TableColumn, TableAction } from '../shared/models/table-models';
import { Router } from '@angular/router';


@Component({
  selector: 'app-questionnaire',
  standalone: true,
  imports: [CommonModule, Table, Popup, TranslatePipe],
  templateUrl: './questionnaire.html',
})
export class Questionnaire implements OnInit {

  icons = AppIcons;

  list: any[] = [];
  columns: TableColumn[] = [];

  showPopup = false;
  isEditMode = false;
  isViewMode = false;
  formData: any = {};

  fields: DynamicFieldConfig[] = [];

  showDeletePopup = false;
  selectedRow: any = null;

  constructor(
    private setup: Setup,
    private toastr: ToastrService,
      private router: Router,
    private translate: TranslateService

  ) {}

  // ================= INIT =================
  ngOnInit(): void {
    this.buildFields();
    this.buildColumns();
    this.loadData();
  }

  // ================= FORM =================
  buildFields() {
    this.fields = [
      {
        key: 'qstnrSeq',
        label: 'QUESTIONNAIRE.ID',
        type: 'text',
        hidden: true,
      },
      {
        key: 'qstnrNm',
        label: 'QUESTIONNAIRE.QUESTIONNAIRE_NAME',
        type: 'text',
        
        validations: { required: true },
        
      },
     
      {
        key: 'qstnrStsKey',
        label: 'COMMON.STATUS',
        type: 'select',
        options$: [
          { label: 'COMMON.ACTIVE', value: 706 },
          { label: 'COMMON.INACTIVE', value: 707 }
        ],
        validations: { required: true },
      },
      {
        key: 'qstnrLvlKey',
        label: 'QUESTIONNAIRE.LEVEL',
        type: 'number',
        validations: { required: true },
      },
      {
        key: 'qstnrCtgryKey',
        label: 'QUESTIONNAIRE.CATEGORY',
        type: 'number',
        validations: { required: true },
      },
      {
        key: 'qstnrRul',
        label: 'QUESTIONNAIRE.RULES',
        type: 'textarea',
        validations: { required: true },
      }
    ];
  }

  // ================= TABLE =================
  buildColumns() {
    this.columns = [
      { key: 'qstnrSeq', label: 'QUESTIONNAIRE.ID' },
      { key: 'qstnrNm', label: 'COMMON.NAME' ,type:'link',onClick: (row: any) => this.goToQuestions(row)
},
      { key: 'qstnrRul', label: 'QUESTIONNAIRE.RULES' },

      {
        key: 'qstnrStsKey',
        label: 'COMMON.STATUS',
        type: 'badge',
        map: {
          706: 'COMMON.ACTIVE',
          707: 'COMMON.INACTIVE'
        },
        badgeMap: {
          706: 'status-active',
          707: 'status-inactive'
        }
      }
    ];
  }
goToQuestions(row: any) {
  this.router.navigate(['/questions', row.qstnrSeq]);
}
  // ================= LOAD =================
 loadData() {
  this.setup.getQuestionnaireList().subscribe({
    next: (res: any) => {

      const data = Array.isArray(res) ? res : (res?.data || []);

      this.list = data.map((q: any) => ({
        qstnrSeq: q.qstnrSeq,
        qstnrNm: q.qstnrNm,
        qstnrId: q.qstnrId,
        qstnrRul: q.qstnrRul,
        qstnrStsKey: q.qstnrStsKey,
        qstnrLvlKey: q.qstnrLvlKey,
        qstnrCtgryKey: q.qstnrCtgryKey
      }));

    },
    error: () => {
      this.list = [];
      this.toastr.error(this.translate.instant('QUESTIONNAIRE.LOAD_FAILED'));
    }
  });
}

  // ================= POPUP =================
  openPopup(data?: any, viewMode: boolean = false) {
    this.showPopup = true;
    this.isViewMode = viewMode;

    if (data) {
      this.isEditMode = true;

      this.formData = {
        qstnrSeq: data.qstnrSeq,
        qstnrNm: data.qstnrNm,
        qstnrId: data.qstnrId,
        qstnrStsKey: data.qstnrStsKey,
        qstnrLvlKey: data.qstnrLvlKey,
        qstnrCtgryKey: data.qstnrCtgryKey,
        qstnrRul: data.qstnrRul,
      };
    } else {
      this.isEditMode = false;

      this.formData = {
        qstnrSeq: null,
        qstnrStsKey: 706,
      };
    }
  }

  // ================= SAVE =================
  handleSave = (form: any) => {

    const payload = {
      qstnrSeq: form.qstnrSeq ?? null,
      qstnrNm: form.qstnrNm,
      qstnrId: form.qstnrId,
      qstnrStsKey: form.qstnrStsKey,
      qstnrLvlKey: form.qstnrLvlKey,
      qstnrCtgryKey: form.qstnrCtgryKey,
      qstnrRul: form.qstnrRul,

      crtdBy: 'admin',
      crtdDt: new Date().toISOString(),
      lastUpdBy: 'admin',
      lastUpdDt: new Date().toISOString(),
      delFlg: false
    };

    return this.setup.saveQuestionnaire(payload).subscribe({
      next: () => {
        this.toastr.success(this.translate.instant(this.isEditMode ? 'QUESTIONNAIRE.UPDATED' : 'QUESTIONNAIRE.CREATED'));
        this.showPopup = false;
        this.loadData();
      },
      error: () => this.toastr.error(this.translate.instant('QUESTIONNAIRE.SAVE_FAILED'))
    });
  };

  // ================= ACTIONS =================
  actions: TableAction[] = [
    {
      icon: this.icons.edit,
      tooltip: 'COMMON.EDIT',
      class: 'action-edit',
      onClick: (row) => this.openPopup(row),
    },
    {
      icon: this.icons.view,
      tooltip: 'COMMON.VIEW',
      class: 'action-view',
      onClick: (row) => this.openPopup(row, true),
    },
    {
      icon: this.icons.delete,
      tooltip: 'COMMON.DELETE',
      class: 'action-delete',
      onClick: (row) => this.openDeletePopup(row),
    }
  ];

  // ================= DELETE =================
  openDeletePopup(row: any) {
    this.selectedRow = row;
    this.showDeletePopup = true;
  }

  confirmDelete(): void {
    if (!this.selectedRow) {
      return;
    }

    const payload = {
      qstnrSeq: this.selectedRow.qstnrSeq ?? null,
      qstnrNm: this.selectedRow.qstnrNm,
      qstnrId: this.selectedRow.qstnrId,
      qstnrStsKey: this.selectedRow.qstnrStsKey,
      qstnrLvlKey: this.selectedRow.qstnrLvlKey,
      qstnrCtgryKey: this.selectedRow.qstnrCtgryKey,
      qstnrRul: this.selectedRow.qstnrRul,

      crtdBy: 'admin',
      crtdDt: new Date().toISOString(),
      lastUpdBy: 'admin',
      lastUpdDt: new Date().toISOString(),
      delFlg: true
    };

    this.setup.saveQuestionnaire(payload).subscribe({
      next: () => {
        this.toastr.success(this.translate.instant('QUESTIONNAIRE.DELETED'));
        this.showDeletePopup = false;
        this.selectedRow = null;
        this.loadData();
      },
      error: () => this.toastr.error(this.translate.instant('QUESTIONNAIRE.DELETE_FAILED'))
    });
  }
}